import React, { FC, useEffect, useRef, useState } from 'react';
import {
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { useCommonStyles } from '../../../styles';

interface Props {
  rowCells: React.ReactNode[];
  subRows: React.ReactNode[];
  columnsNumber: number;
}

export const ReportsCollapsibleRow: FC<Props> = ({
  rowCells,
  subRows,
  columnsNumber,
}) => {
  const [open, setOpen] = useState(false);
  const commonClasses = useCommonStyles();
  const parentRowRef = useRef<HTMLTableRowElement | null>(null);
  const [colWidths, setColWidths] = useState<number[]>([]);

  useEffect(() => {
    if (!parentRowRef.current) return;

    const cells = parentRowRef.current.querySelectorAll('td');

    const widths = Array.from(cells).map((cell) =>
      cell.getBoundingClientRect().width,
    );

    setColWidths(widths);
  }, [rowCells]);

  return (
    <>
      {/* Group row */}
      <TableRow className={commonClasses.collapsibleRow} ref={parentRowRef}>
        {/* expand column */}
        <TableCell style={{ width: 30, padding: '6px 16px' }}>
          <IconButton size="small" onClick={() => setOpen((prev) => !prev)}>
            {open ? <ExpandMore /> : <ExpandLess />}
          </IconButton>
        </TableCell>

        {/* actual data cells */}
        {rowCells}
      </TableRow>

      {/* Collapsible content */}
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={columnsNumber}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Table size="small">
              <colgroup>
                {colWidths.map((width) => (
                  <col key={`col-${width}`} style={{ width }} />
                ))}
              </colgroup>

              <TableBody>{subRows}</TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
